import {
  createPageEventObject,
  extractMainProperties,
  extractUserProperties,
  normalizeUserEg,
} from "./utils";
import sendGaPageEvent from "@gerenciatd/next13.utils.metrics.send-ga-page-event";
import secureCookieStorage from "@gerenciatd/next13.utils.secure.local-storage";
const normalizeZipCode = (zipcode) => {
  let res = "";
  if (zipcode === "ZR") res = "regulada";
  if (zipcode === "ZL") res = "libre";
  if (zipcode === "ZM") res = "mixta";
  return res;
};

const isUserLoggedIn = (context) => {
  let res = false;
  if (context) {
    res =
      context.userIdPartyHash ||
      context.userCUCFijoHash ||
      context.userCUCMovilHash ||
      context.userCUCPrepagoHash;
  }
  return res;
};

/**
 * Envio a GA sobre info el usuario según valor de cookies
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const sendGaConfig = async ({ context, shouldSendHash, setContextData }) => {
  const data = createPageEventObject(context);
  const secureCookieStorageLib = new secureCookieStorage();
  const persistedInfo = secureCookieStorageLib.getItem("ts");
  const { userIdPartyHashFromGetEg, userPq } = persistedInfo;
  const mainProperties = extractMainProperties(data);
  const userProperties = extractUserProperties(data, shouldSendHash, userIdPartyHashFromGetEg);
  const zipcode = normalizeZipCode(persistedInfo?.geo?.zone || "");
  const logado = isUserLoggedIn(context);
  const normalizeEg = normalizeUserEg(persistedInfo);
  let userPo = '';
  if(userPq && userPq.userPo) {
    userPo = JSON.stringify(userPq.userPo);
  }
  try {
    gtag("config", `${process.env.NEXT_PUBLIC_GTM_ID}`, {
      page_variation: logado ? "cliente" : "no-cliente",
      transport_url: "https://landings.dev.col.movistar.es",
      first_party_collection: true,
      ...mainProperties,
      ...userProperties,
      "zip-code": zipcode,
      user_po: userPo,
      ...normalizeEg,
    });

    gtag("get", "G-J1GJWFY08P", "session_id", (sessionId) => {
      if (context && context.clientIDs) {
        context.clientIDs.sessionId = sessionId;
        setContextData(context);
      }
    });
  } catch (e) {
    console.log(e);
  }

  // Envia a GA el evento page_printed una vez ya tiene toda la info
  sendGaPageEvent();
};

/**
 * Actualiza si el cliente ha aceptado las cookies.
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
export const gaEvents = async ({
  context,
  setContextData,
  ad_storage,
  analytics_storage,
  ad_user_data,
  ad_personalization,
}) => {
  const shouldSendHash = ad_storage === "granted" && analytics_storage === "granted";
  if (ad_storage !== "denied" || analytics_storage !== "denied") {
    try {
      gtag("consent", "update", {
        ad_storage,
        analytics_storage,
        ad_user_data,
        ad_personalization,
      });
    } catch (e) {
      console.log(e);
    }
  }
  sendGaConfig({ context, shouldSendHash, setContextData });
};

export default gaEvents;
